"use client";

import { SizesUI } from "./SizesUI";
import { StandardProps } from "../componentMap";
import { hasSizes } from "../../utils/product/hasSizes";
import { FitToolAndSizeChart } from "../FitToolAndSizeChart/FitToolAndSizeChart";
import { useAvailableSizes } from "./utils";
import { SizeAndFitCta } from "../SizeAndFitCta/SizeAndFitCta";

export function Sizes({
  product,
  configProps,
  runtimeConfig,
  experiences,
}: Pick<
  StandardProps,
  "product" | "configProps" | "runtimeConfig" | "experiences"
>) {
  const isGroupingAllowed = configProps?.allowGrouping === true;
  const isSortingEnabled = configProps?.sortSizes === true;
  const showMore =
    typeof configProps?.showMore === "number"
      ? configProps?.showMore
      : undefined;

  const sizesList = useAvailableSizes(product, experiences, {
    sortSizes: isSortingEnabled,
  });

  if (!hasSizes(product)) {
    return null;
  }

  return (
    <>
      {configProps?.withFitToolAndSizeChart ? (
        <FitToolAndSizeChart product={product} runtimeConfig={runtimeConfig} />
      ) : null}
      <SizesUI
        sizes={sizesList}
        isGroupingAllowed={isGroupingAllowed}
        showMore={showMore}
      />
      {configProps?.withSizeAndFitCTA ? (
        <SizeAndFitCta product={product} />
      ) : null}
    </>
  );
}
